<select class="form-select" [(ngModel)]="comparison">
  <option value="" >Select a comparison</option>
  <option value="==">Equals</option>
  <option value="!=">Does not equal</option>
  <option value="%*">Begins</option>
  <option value="*%">Ends</option>
  <option value="%*%">Contains</option>
  <option value="#">Is a number</option>
  <option value="!#">Is not a number</option>
  <option value="+#">Is a positive number</option>
  <option value="-#">Is a negative number</option>
  <option value="" >Is Empty</option>
  <option value="!!">Has a value</option>
</select>
